module.exports = __webpack_public_path__ + "static/media/unibank.79bf288e.svg";